import React from 'react';

const WhyChooseUs = () => {
  return (
    <div
      style={{
        backgroundColor: "#f9f9f9", // Light background for section
        padding: "50px 20px", // Spacing
        textAlign: "center",
      }}
    >
      {/* Section Heading */}
      <h2
        style={{
          fontSize: "2.5rem",
          fontWeight: "600",
          color: "rgba(35, 120, 97, 1)", // Dark color for heading
          marginBottom: "30px",
        }}
      >
        Why Choose Us?
      </h2>

      {/* List of Features */}
      <div
        style={{
          display: "flex",
          flexDirection: "column", // Stack the items vertically
          alignItems: "flex-start", // Align items to the left
          gap: "20px", // Space between each item
          maxWidth: "800px", // Max width for readability
          marginLeft: "auto", // Center content
          marginRight: "auto",
        }}
      >
        {/* Quality Construction */}
        <div
          style={{
            fontSize: "1.2rem",
            color: "#444",
            display: "flex",
            alignItems: "center", // Ensure checkmark and text are horizontally aligned
            gap: "15px", // Space between the checkmark and text
          }}
        >
          <span
            style={{
              color: "green", // Green color for checkmark
              fontSize: "1.5rem", // Larger checkmark
            }}
          >
            ✔
          </span>
          <span>
            <strong>Quality Construction </strong> – Using premium materials and advanced techniques.
          </span>
        </div>

        {/* Affordable Pricing */}
        <div
          style={{
            fontSize: "1.2rem",
            color: "#444",
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <span
            style={{
              color: "green",
              fontSize: "1.5rem",
            }}
          >
            ✔
          </span>
          <span>
           <strong> Affordable Pricing </strong> – Ensuring cost-effective solutions without compromising on features.
          </span>
        </div>

        {/* Prime Locations */}
        <div
          style={{
            fontSize: "1.2rem",
            color: "#444",
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <span
            style={{
              color: "green",
              fontSize: "1.5rem",
            }}
          >
            ✔
          </span>
          <span>
           <strong> Prime Locations </strong>– Strategically situated properties in Dhanbad.
          </span>
        </div>

        {/* Customer-Centric Approach */}
        <div
          style={{
            fontSize: "1.2rem",
            color: "#444",
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <span
            style={{
              color: "green",
              fontSize: "1.5rem",
            }}
          >
            ✔
          </span>
          <span>
            <strong>Customer-Centric Approach </strong>– Dedicated to transparency, trust, and satisfaction.
          </span>
        </div>
      </div>

      {/* Main Description */}
      <div
        style={{
          marginTop: "40px",
          fontSize: "1.2rem",
          color: "#444",
          fontStyle: "italic",
          textAlign: "center",
          maxWidth: "800px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        At Maniraj Builder, we are not just building houses—we are creating homes and commercial spaces that enrich
        lives.
      </div>
    </div>
  );
};

export default WhyChooseUs;
